import { useMemo, useState } from 'react'

import { useNavigate, useParams } from 'react-router'

import { Page } from '@/components/layout/page/page.tsx'
import { Skeleton } from '@/components/ui/skeleton.tsx'
import { useAccount } from '@/modules/accounts/hooks/useAccounts.ts'
import { usePpvTracking } from '@/modules/tracking/ppv/hooks/usePpvTracking.tsx'
import { PpvCategoryMediaSetsTable } from '@/modules/tracking/ppv/ui/category/PpvCategoryMediaSetsTable.tsx'
import { PpvCategoryTopPage } from '@/modules/tracking/ppv/ui/category/PpvCategoryTopPage.tsx'
import { AppRoutes } from '@/utils/constants.ts'
import { useCreatorUrl } from '@/utils/creators.ts'

export const PpvTrackingCategoryPage = () => {
  const { categoryIndex } = useParams()
  const { userSettings } = useAccount()
  const shouldShowCents = useMemo(
    () => userSettings?.showCents,
    [userSettings?.showCents],
  )
  const { allCategories, isFetching } = usePpvTracking()
  const navigate = useNavigate()
  const [mediaSetSearchQuery, setMediaSetSearchQuery] = useState('')

  const category =
    allCategories &&
    categoryIndex &&
    allCategories.length >= parseInt(categoryIndex) + 1
      ? allCategories[parseInt(categoryIndex)]
      : undefined
  const mediaSets = useMemo(() => {
    return category?.mediaSets.filter(
      (mediaSet) =>
        mediaSet.highlighted.content
          .toLowerCase()
          .match(mediaSetSearchQuery.toLowerCase()) ||
        mediaSet.highlighted.mediaLabel
          .toLowerCase()
          .match(mediaSetSearchQuery.toLowerCase()),
    )
  }, [category?.mediaSets, mediaSetSearchQuery])

  const listUrl = useCreatorUrl(AppRoutes.Creator.ChatterTracking.Ppv.List)

  if (!allCategories || isFetching) {
    return (
      <Page
        className="mb-6"
        title="Loading..."
        titleClassName="text-3xl"
      >
        <Skeleton className="h-80 w-full" />{' '}
      </Page>
    )
  }

  if (!category || !mediaSets) {
    navigate(listUrl)

    return
  }

  return (
    <Page above={<PpvCategoryTopPage category={category} />}>
      <PpvCategoryMediaSetsTable
        mediaSets={mediaSets}
        setSearch={setMediaSetSearchQuery}
        showCents={shouldShowCents}
      />
    </Page>
  )
}
